import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../header/Header";

import "./Main.scss";

const Main: React.FC = () => {
  return (
    <div className="main">
      <Header />
      <Outlet />
    </div>
  );
};
export default Main;
